<template>
  <v-container fluid class="pa-0 company-users-list-container">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            class="admin-list-table"
            :headers="headers"
            :items="companyBranches"
            :loading="false"
            :sort-by="['code']"
            :search="search"
            @click:row="showEditBranchDialog"
          >
            <template #top>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" md="4" class="pa-md-6">
                    <v-text-field
                      v-model="search"
                      :append-icon="icons.mdiMagnify"
                      label="Search"
                      single-line
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { COMPANY_BRANCHES_QUERY } from '../../../constants/graphql/branches';

  export default {
    name: 'CompanyBranchesList',
    props: {
      companyId: {
        default: undefined,
        type: String,
      },
    },
    data() {
      return {
        roleFilterValue: null,
        search: '',
        companyBranches: [],
        dates: [],
        dateMenu: false,
      };
    },
    computed: {
      headers() {
        return this.allHeaders;
      },
      allHeaders() {
        return [
          { text: 'Branch code', value: 'code' },
          { text: 'Description', value: 'description' },
          { text: 'Company ID', value: 'companyId' },
        ];
      },
      rolesList() {
        var list = [
          { text: 'All', value: null },
          { text: 'Company admins', value: 'COMPANY_ADMIN' },
          { text: 'Advisors', value: 'ADVISOR' },
        ];

        return list;
      },
    },
    methods: {
      redirectToSummary(item) {},
      closeMenu() {},
      clearDates() {},
      showEditBranchDialog(item) {
        this.$emit('showEditBranchDialog', item);
      },
    },
    apollo: {
      companyBranches: {
        query: COMPANY_BRANCHES_QUERY,
        variables() {
          return {
            id: this.companyId,
          };
        },
        fetchPolicy: 'network-only',
      },
    },
  };
</script>
